import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IOrganisationAdditionalChargeType } from '../interfaces/organisation-additional-charge-type';
import { IOrganisationAdditionalChargeTypeFilterField } from '../interfaces/organisation-additional-charge-filter';
import { IPageResult } from '../interfaces/page-result';

@Injectable({ providedIn: 'root' })
export class OrganisationAdditionalChargeTypeService extends ReadService<any, any> {
  url = '/api/organisation-additional-charge-type';
  entityTitle = 'Organisation Additional Charge Type Setting';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAll(
    filter: IOrganisationAdditionalChargeTypeFilterField,
  ): Promise<IPageResult<IOrganisationAdditionalChargeType>> {
    let params = this.constructHttpParams(filter);
    return this.http
      .get(`${this.url}/all`, { headers: new HttpHeaders({}), params: params })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public create(dto: IOrganisationAdditionalChargeType) {
    const url = `${this.url}`;
    return this.handleRequest<number>(
      this.http.post<number>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  public update(id: number, dto: IOrganisationAdditionalChargeType) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<number>(
      this.http.put<number>(url, dto),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  public delete(id: number) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<boolean>(
      this.http.delete<boolean>(url),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }
}
